import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';

import { GuideComponent } from 'app/shared/components/guide/guide.component';
import { OnboardingService } from 'app/services/onboarding.service';
import { Onboarding } from 'app/models/onboarding';
import { File } from 'app/models/file';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit, OnDestroy {

  bsModalRef: BsModalRef;
  files: Array<File>;
  coverPage: File;
  private routerSub = Subscription.EMPTY;

  constructor(
    private onboardingService: OnboardingService,
    private modalService: BsModalService,
    private router: Router,
  ) {
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event)
    ).subscribe((val) => {
      this.getData();
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.routerSub.unsubscribe();
  }

  getData(): void {
    if (this.router.url.indexOf('onboarding') > -1) {
      this.onboardingService.getAll().subscribe(res => {
        this.files = res.filter((f) => !f.coverPage);
        this.coverPage = res.filter((f) => f.coverPage)[0] ||
                         new File(null, null, null, null, null, null, null, null, null);
      });
    }
  }

  openGuide() {
    this.bsModalRef = this.modalService.show(GuideComponent, {
        class: 'gray modal-lg',
        backdrop: 'static'
    });
  }

  attachDocument(event) {
    this.onboardingService.create(event.dragData).subscribe((res) => this.getData());
  }

  removeDocument(event) {
    this.onboardingService.remove(event.id).subscribe((res) => this.getData());
  }

  saveCoverPage(event) {

    this.onboardingService.saveCoverPage(event).subscribe((res) => this.getData());
  }
}
